import React, { Children, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChangeoutputPinState } from "../../../../../../store/service-actions"
import Card from "../../../../Cards/Card";

import classes from "./EditPinOutput.module.css";
import InactiveIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/Pin/default - Off.svg";
import HiddenIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/HiddenPin.svg";
import SettingCogIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/__Admin - Settings.svg"
import { Checkbox } from "primereact/checkbox";
import { pinFormat } from "../../../../../../helpers/PinFormat";


const EditPinOutput = ({ OutPutPin, polarity, HandleShowEditPinForm, setPinDetails, selectedPins, setSelectedPins }) => {
    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const userID = useSelector(state => state.auth.userID);

    const { pinName, pinStatusOff, pinStatusOn, pinState, icon, DeviceUUID, Pin, active, notificationActive, type } = OutPutPin

    const image = icon + " - Off";
    const otherStateImage = icon + " - On";
    const staticPath = "/assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/";

    const imageFromPath = `${process.env.PUBLIC_URL}${staticPath}${image}.svg`
    let otherStateImageFromPath = `${process.env.PUBLIC_URL}${staticPath}${otherStateImage}.svg`;

    const initialPinState = polarity === 1 ? !pinState : pinState;

    const [PinState, setPinState] = useState(initialPinState);
    const [pinStateLoading, setPinStateLoading] = useState(false);

    const isSelected = selectedPins?.has(Pin);

    const toggleSelected = (e) => {
        setSelectedPins(prev => {
            const next = new Set(prev);
            if (e.checked) {
                next.add(Pin);
            } else {
                next.delete(Pin);
            }
            return next;
        });
    };

    useEffect(() => {
        //if external source updates the state, update PinState to reflect that
        setPinState(pinState);
    }, [pinState]);

    return (
        <Card className={classes["pin-switch-edit"]} onClick={() => {HandleShowEditPinForm(); setPinDetails(OutPutPin)}}>
            <div style={{ display: 'flex', flexDirection: 'row'}}>
                <div className={classes.top}>
                    <div className={classes["top-left"]}>
                        <h3 className={classes.lable}>{pinName}</h3>
                        <h3 className={` ${classes.lable}  ${active ? classes.active : classes.inactive}`}>
                            {active ? "Visible in app" : "Not visible in app"}
                        </h3>
                    </div>
                    <div className={classes["top-right"]}>
                        <img className={classes.img} src={SettingCogIcon} />
                    </div>
                </div>
                <Checkbox checked={isSelected} onChange={toggleSelected} onClick={(e) => e.stopPropagation()} />
                
            </div>

            <div className={classes.bottom}>
                <div style={{ backgroundColor: active ? `#168AAD` : "grey", borderRadius: "50%", width: "12px", height: "12px" }} />
            </div>
            <div className={classes["bottom-right"]}>
                <p style={{ margin: 0, color: '#a9a9a9' }}>{pinFormat.Output[OutPutPin.Pin]}</p>
            </div>
        </Card>
    );
}

export default EditPinOutput;